'use client';

import React, { useState, useEffect } from 'react';
import { ShoppingCart, Clock, Tablet } from 'lucide-react';

export default function PickingHeader() {
  const [dateStr, setDateStr] = useState('');
  const [timeStr, setTimeStr] = useState('');

  useEffect(() => {
    const update = () => {
      const now = new Date();
      setDateStr(now?.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }));
      setTimeStr(now?.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true }));
    };
    update();
    const interval = setInterval(update, 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <header className="flex items-center justify-between px-5 py-4 border-b border-border bg-card flex-shrink-0">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-accent/15 flex items-center justify-center">
          <ShoppingCart size={22} className="text-accent" />
        </div>
        <div>
          <h1 className="text-base font-bold text-foreground tracking-tight">Picking — FEFO Queue</h1>
          <p className="text-2xs text-muted-foreground">QC-approved items · FEFO batch priority · Scan to confirm pick</p>
        </div>
      </div>
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-muted/50">
          <Tablet size={13} className="text-muted-foreground" />
          <span className="text-xs text-muted-foreground">Operator View</span>
        </div>
        {dateStr && (
          <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
            <Clock size={13} />
            <span>{dateStr} · {timeStr}</span>
          </div>
        )}
      </div>
    </header>
  );
}
